import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMagnifier20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMagnifier20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.51 9.51a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-1.543 6.518a8.5 8.5 0 1 1 1.06-1.06l2.667 2.665a.75.75 0 1 1-1.06 1.06z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMagnifier20);
